export default __webpack_public_path__ + "static/media/pictogramID64.82e0a890.svg";